exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-table[data-v-524cd25e] {\n  margin-bottom: 20px;\n  z-index: 1;\n  display: flex;\n  width: 100%;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n}\n", ""]);

// exports
